<template>
  <b-tabs pills content-class="mt-2 mb-4" v-if="value">
    <b-tab active>
      <template slot="title">
        Generale
        <b-badge variant="danger"
          v-if="countErrors('name')">
          {{ countErrors('name') }}
        </b-badge>
      </template>
      <form>
        <string-form-field
          label="Nome"
          required
          :value="value.name"
          :disabled="disabled"
          :error="findError('name')"
          @input="propertyChanged('name', $event)"
        />
      </form>
    </b-tab>
    <b-tab>
      <template slot="title">
        Utenti
        <b-badge variant="danger"
          v-if="countErrors('users')">
          {{ countErrors('users') }}
        </b-badge>
      </template>
      <b-alert
        v-if="findError('users')"
        show
        variant="danger">
        {{ findError('users') }}
      </b-alert>
      <data-table
        :columns="usersColumns"
        :value="value.users"
        empty-message="Nessun utente trovato"
      />
      <div class="text-right" v-if="!disabled">
        <b-button variant="success" @click.prevent="addUser">
          <i class="fa fa-fw fa-plus"></i> Aggiungi
        </b-button>
      </div>

      <b-modal
        modal-class="h-100"
        dialog-class="h-100"
        ref="rolesModal"
        size="xl"
        scrollable
        :title="selectedUser === null ? null : value.users[selectedUser].user.displayName"
        :ok-only="disabled"
        @ok="confirmRoles"
        @cancel="cancelRoles"
        @close="cancelRoles">
        <template v-if="selectedUser !== null && value.users[selectedUser]">
          <role-form-field
            multiple
            :dropdown="false"
            :disabled="disabled"
            :value="selectedRoles"
            :parameters="{
              workgroupIds: [ value.id ],
              nwi: true
            }"
            @input="rolesChanged($event)"
          />
        </template>
      </b-modal>
    </b-tab>
    <b-tab>
      <template slot="title">
        Inviti
        <b-badge variant="danger"
          v-if="countErrors('invitations')">
          {{ countErrors('invitations') }}
        </b-badge>
      </template>
      <b-alert
        v-if="findError('invitations')"
        show
        variant="danger">
        {{ findError('invitations') }}
      </b-alert>
      <data-table
        :columns="invitationsColumns"
        :value="value.invitations"
        empty-message="Nessun invito trovato"
      />
      <div class="text-right" v-if="!disabled">
        <b-button variant="success" @click.prevent="addInvitation">
          <i class="fa fa-fw fa-plus"></i> Aggiungi
        </b-button>
      </div>
    </b-tab>
  </b-tabs>
</template>
<script>
import EntityEditorMixin from 'vue-core/mixins/EntityEditorMixin';
import * as moment from 'moment';

export default {
  mixins: [ EntityEditorMixin ],

  data() {
    return {
      selectedRoles: null,
      selectedUser: null,
    };
  },

  watch: {
    selectedUser(newValue) {
      if (newValue !== null) {
        this.selectedRoles = [ ...this.value.users[this.selectedUser].roles ];
        this.$refs.rolesModal.show();
      } else {
        this.selectedRoles = null;
        this.$refs.rolesModal.hide();
      }
    }
  },

  created() {
    this.usersColumns = [
      {
        label: '',
        style: 'max-width: 100px;',
        type: 'actions',
        actions: (item, index) => [
          {
            icon: 'list',
            buttonClass: 'text-success pl-0',
            exec: () => {
              this.selectedUser = index;
            }
          },
          {
            show: !this.disabled,
            icon: 'times',
            buttonClass: 'text-danger',
            exec: () => {
              const users = [ ...this.value.users ];
              users.splice(index, 1);
              this.propertyChanged('users', users);
            }
          }
        ]
      },
      {
        label: 'Utente',
        type: 'component',
        component: 'user-form-field',
        class: 'col mb-0',
        props: (item, index) => ({
          disabled: this.disabled,
          value: item.user,
          error: this.findError('users[' + index + '].user')
        }),
        events: (item, index) => ({
          input: (v) => {
            const users = [ ...this.value.users ];
            users[index] = { ...item, user: v };
            this.propertyChanged('users', users);
          }
        })
      },
      {
        label: 'Attivo',
        type: 'component',
        component: 'boolean-form-field',
        class: 'col-2 mb-0 text-center',
        style: 'max-width: 130px;',
        props: (item, index) => ({
          disabled: this.disabled,
          value: item.enabled,
          error: this.findError('users[' + index + '].enabled')
        }),
        events: (item, index) => ({
          input: (v) => {
            const users = [ ...this.value.users ];
            users[index] = { ...item, enabled: v };
            this.propertyChanged('users', users);
          }
        })
      },
      {
        label: 'Tipo',
        type: 'component',
        component: 'options-form-field',
        class: 'col-2 mb-0 text-center',
        //style: 'max-width: 130px;',
        props: (item, index) => ({
          disabled: this.disabled,
          value: item.type,
          error: this.findError('users[' + index + '].type'),
          dropdown: true,
          options: [
            { text: 'Amministratore'  , value: 'ADMINISTRATOR' },
            { text: 'Utente ordinario', value: 'ORDINARY'      },
            { text: 'Ospite'          , value: 'GUEST'         },
          ]
        }),
        events: (item, index) => ({
          input: (v) => {
            const users = [ ...this.value.users ];
            users[index] = { ...item, type: v };
            this.propertyChanged('users', users);
          }
        })
      },
      /*
      {
        label: 'Ospite',
        type: 'component',
        component: 'boolean-form-field',
        class: 'col-2 mb-0 text-center',
        style: 'max-width: 130px;',
        props: (item, index) => ({
          disabled: this.disabled,
          value: item.guest,
          error: this.findError('users[' + index + '].guest')
        }),
        events: (item, index) => ({
          input: (v) => {
            const users = [ ...this.value.users ];
            users[index] = { ...item, guest: v };
            this.propertyChanged('users', users);
          }
        })
      },
      */
    ];

    this.invitationsColumns = [
      {
        label: '',
        style: 'max-width: 100px;',
        type: 'actions',
        show: !this.disabled,
        actions: (item, index) => [
          {
            icon: 'times',
            buttonClass: 'text-danger',
            exec: () => {
              const invitations = [ ...this.value.invitations ];
              invitations.splice(index, 1);
              this.propertyChanged('invitations', invitations);
            }
          }
        ]
      },
      {
        label: 'E-mail',
        type: 'component',
        component: 'string-form-field',
        class: 'col mb-0',
        props: (item, index) => ({
          disabled: this.disabled,
          value: item.userEmail,
          error: this.findError('invitations[' + index + '].userEmail')
        }),
        events: (item, index) => ({
          input: (v) => {
            const invitations = [ ...this.value.invitations ];
            invitations[index] = { ...item, userEmail: v };
            this.propertyChanged('invitations', invitations);
          }
        })
      },
      {
        label: 'Scadenza invito',
        type: 'component',
        component: 'date-form-field',
        class: 'col mb-0',
        props: (item, index) => ({
          disabled: this.disabled,
          value: item.expiration,
          error: this.findError('invitations[' + index + '].expiration')
        }),
        events: (item, index) => ({
          input: (v) => {
            const invitations = [ ...this.value.invitations ];
            invitations[index] = { ...item, expiration: v };
            this.propertyChanged('invitations', invitations);
          }
        })
      },
    ];
  },

  methods: {
    confirmRoles() {
      const users = [ ...this.value.users ];
      const u = { ...users[this.selectedUser] };
      u.roles = this.selectedRoles;
      users[this.selectedUser] = u;
      this.selectedUser = null;
      this.propertyChanged('users', users);
    },

    cancelRoles() {
      this.selectedUser = null;
    },

    rolesChanged(newRoles) {
      // console.log('newRoles', newRoles);
      this.selectedRoles = newRoles;
    },

    addUser() {
      const users = [ ...this.value.users ];
      users.push({
        user: null,
        enabled: true,
        administrator: false,
        guest: true,
        roles: [],
      });
      this.propertyChanged('users', users);
    },

    addInvitation() {
      const invitations = [ ...this.value.invitations ];
      invitations.push({
        userEmail: null,
        expiration: moment().add(7, 'days'),
      });
      this.propertyChanged('invitations', invitations);
    }
  }
}
</script>
